export default "__VITE_ASSET__4d994309__"